module.exports = __webpack_public_path__ + "img/khairul 1.99214127.png";